export class ServicesConfig {
  firebase: {
    chat: string;
  };
  apiEndpoints: {
    history: string;
  };
}
